import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../../translate/Translate';

// Components
import Primary from './Primary';
import Outline from './Outline';
import Positive from './Positive';
import Negative from './Negative';
import Ghost from './Ghost';
import Usage from './Usage';

const Button = observer(class Button extends React.Component {
  render() {
		const { activeTab } = this.props;

		if(activeTab === 'examples') {
			return (
				<div className="wrap">
					<Primary {...this.props} />
					<Outline {...this.props} />
					<Positive {...this.props} />
					<Negative {...this.props} />
					<Ghost {...this.props} />
				</div>
			)
		} else if(activeTab === 'usage') {
			return (
				<div className="wrap">
					<Usage {...this.props} />
				</div>
			)
		}
  }
})

export default translate('Button')(Button);
